import { render } from "./CrmDealKanbanDealDataModalReportModalSalesPackagesComponent.vue?vue&type=template&id=0d66160c"
import script from "./CrmDealKanbanDealDataModalReportModalSalesPackagesComponent.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModalReportModalSalesPackagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__